/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classnames from 'classnames';
import * as React from 'react';

/**
 * Configuration for the empty placeholder image.
 */
export interface IEmptyPlaceholderImageProps {
    /**
     * The html class name to use for the html element. Will be used along with the default classes.
     */
    className?: string;
}

/**
 * React component responsible for rendering an empty placeholder image
 * which should be used to be displayed when main image is unaccessible or broken.
 *
 * The element is an empty div element by default. Use css styles for the class in order to specify the image for the component.
 */
export class EmptyPlaceholderImage extends React.PureComponent<IEmptyPlaceholderImageProps> {
    /**
     * The default class for empty image component.
     */
    private static _emptyImageClassName: string = 'msc-empty_image';

    /**
     * Initializes instance with the given props.
     * @param {IEmptyPlaceholderImageProps} props - Configuration for the empty placeholder image.
     */
    public constructor(props: IEmptyPlaceholderImageProps) {
        super(props);
    }

    /**
     * Renders empty placeholder image.
     *
     * The element is an empty div element by default. Use css styles for the class in order to specify the image for the component.
     */
    public render(): React.ReactNode {
        return <div className={classnames(EmptyPlaceholderImage._emptyImageClassName, this.props.className)} />;
    }
}
